"use strict";function recycle$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.recycle$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="ui.nav.recycle";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0"},_a)),exports.recycle$=recycle$,exports.default=recycle$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/ui/nav/recycle.js
// module id = 1096
// module chunks = 106